import { render, staticRenderFns } from "./FooterBarRightButtonProxy.vue?vue&type=template&id=1cb0c800"
import script from "./FooterBarRightButtonProxy.vue?vue&type=script&lang=ts"
export * from "./FooterBarRightButtonProxy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports